import { render, staticRenderFns } from "./coloredSvgImg.vue?vue&type=template&id=092d1c12&scoped=true&"
import script from "./coloredSvgImg.vue?vue&type=script&lang=js&"
export * from "./coloredSvgImg.vue?vue&type=script&lang=js&"
import style0 from "./coloredSvgImg.vue?vue&type=style&index=0&id=092d1c12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d1c12",
  null
  
)

export default component.exports